var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("app-detail-header", {
        attrs: {
          "show-toggle": true,
          "show-new": false,
          "show-print": false,
          "show-delete": false,
          "show-save": true,
        },
        on: { appDetailHeaderButtonClicked: _vm.onHeaderButtonClicked },
      }),
      _c("div", { staticClass: "columns is-gapless" }, [
        _c(
          "div",
          { staticClass: "column is-narrow" },
          [
            _vm.entity
              ? _c("orm-batching-view-side-menu", {
                  ref: "sideMenu",
                  attrs: { "entity-name": `${_vm.entity.batchNo}` },
                })
              : _vm._e(),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "column" },
          [
            _vm.entity
              ? _c("router-view", {
                  key: _vm.$route.fullPath,
                  attrs: {
                    "route-name": _vm.$route.name,
                    "is-add-quote-active": _vm.isAddQuoteActive,
                  },
                  on: {
                    "update:isAddQuoteActive": function ($event) {
                      _vm.isAddQuoteActive = $event
                    },
                    "update:is-add-quote-active": function ($event) {
                      _vm.isAddQuoteActive = $event
                    },
                    "view-quote": _vm.viewQuote,
                  },
                  model: {
                    value: _vm.entity,
                    callback: function ($$v) {
                      _vm.entity = $$v
                    },
                    expression: "entity",
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
      _c(
        "unsaved-modal",
        {
          attrs: { active: _vm.isUnsavedModalActive },
          on: {
            "update:active": function ($event) {
              _vm.isUnsavedModalActive = $event
            },
            close: function ($event) {
              return _vm.closeModal()
            },
            skipSave: function ($event) {
              return _vm.skipSave()
            },
            saveContinue: function ($event) {
              return _vm.saveContinue()
            },
          },
        },
        [
          _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
            _vm._v("Unsaved Changes"),
          ]),
          _c("p", { attrs: { slot: "text-content" }, slot: "text-content" }, [
            _vm._v("There are unsaved changes. Please select action below"),
          ]),
        ]
      ),
      _c("vue-fab", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.entity,
            expression: "entity",
          },
        ],
        attrs: {
          "main-tooltip": "Batch Actions",
          position: "bottom-right",
          "z-index": 30,
          actions: _vm.fabActions,
        },
        on: {
          submitQuotes: _vm.submitQuotes,
          submitInvoices: _vm.submitInvoices,
          toggleAddQuotes: _vm.toggleAddQuotes,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }